import React, { FC, useEffect } from 'react'

import { map } from 'lodash'

import { useAuthentication } from 'utils/authentication'
import { Tool, ToolType } from '__generated__/api-types-and-hooks'
import { IGetCalendarEventsPayload } from '../types'

import Block from 'components/Owner/Tools/Block'
import { CalendarToolWrapper } from 'components/Calendar/style'
import Loader from 'components/Loaders'
import useGetStartEndDate from 'hooks/useGetStartEndDate'
import moment from 'moment'

interface ICalendarTools {
  oAuthUrl: string
  toolsByType: Tool[]
  isToolsByTypeLoading: boolean
  getOAuthUrlAction: (payload) => void
  getToolsByTypeAction: (payload) => void
  resetOAuthUrlAction: () => void
  toolConnectionSuccessAction: (payload) => void
  getUserConnectorsAction: (payload) => void
  getUserCalendarEventsAction: (payload: IGetCalendarEventsPayload) => void
  getMyToolsAction: () => void
  currentCalendarDate: Date
}

const CalendarTools: FC<ICalendarTools> = ({
  oAuthUrl,
  toolsByType,
  isToolsByTypeLoading,
  getOAuthUrlAction,
  getToolsByTypeAction,
  resetOAuthUrlAction,
  toolConnectionSuccessAction,
  getUserConnectorsAction,
  getUserCalendarEventsAction,
  getMyToolsAction,
  currentCalendarDate,
}) => {
  const { start_date, end_date } = useGetStartEndDate(currentCalendarDate)
  const payload = {
    calendarName: '',
    timeMin: moment(start_date).format('YYYY-MM-DDTHH:mm:ss-00:00'),
    timeMax: moment(end_date).format('YYYY-MM-DDTHH:mm:ss-00:00'),
  }
  useEffect(() => {
    getToolsByTypeAction({ toolType: ToolType.Calendar })
    // eslint-disable-next-line
  }, [])

  useAuthentication(oAuthUrl, getUserConnectorsAction, resetOAuthUrlAction)
  return (
    <CalendarToolWrapper>
      {isToolsByTypeLoading ? (
        <Loader loader="CalendarToolsLoader" />
      ) : (
        <>
          {map(toolsByType, (tool: Tool) => (
            <Block
              tool={tool}
              key={tool.id}
              setActiveConnectingTool={() => {}}
              getOAuthUrlAction={getOAuthUrlAction}
              onDisconnect={() => {
                getUserCalendarEventsAction(payload)
                getMyToolsAction()
              }}
            />
          ))}
        </>
      )}
    </CalendarToolWrapper>
  )
}
export default CalendarTools
